import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ResumoVo} from '~model/vo/resumo-vo';

@Component({
  selector: 'app-resumo-rota-dialog',
  template: '<app-resumo-rota [resumo]="data"></app-resumo-rota>',
})
export class ResumoRotaDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ResumoVo) {
  }
}
